import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "refund-order-index-content"
};
import FilterHeader from './components/FilterHeader.vue';
import RefundTableBlock from "@/views/orderManage/refundOrder/components/RefundTableBlock.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'refundOrderIndex',
  setup(__props) {
    const tableRef = ref(null);
    const loading = ref(false);
    const filterSubmit = obj => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(obj);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(FilterHeader, {
        onFilterSubmit: filterSubmit,
        loading: loading.value
      }, null, 8, ["loading"]), _createVNode(RefundTableBlock, {
        ref_key: "tableRef",
        ref: tableRef,
        "table-type": "2"
      }, null, 512)]);
    };
  }
});